/**
 * Helpers for detecting and unpacking daily-quota (402) errors from the API.
 */

export function isQuotaError(err) {
  const status = err?.response?.status;
  if (status !== 402) return false;
  const detail = err?.response?.data?.detail;
  return typeof detail === "object" && detail !== null && detail.quota_exceeded === true;
}

/** 402 with detail.error === "upgrade_required" — the free-tier upgrade gate. */
export function isUpgradeError(err) {
  const detail = err?.response?.data?.detail;
  return (
    err?.response?.status === 402 &&
    typeof detail === "object" &&
    detail !== null &&
    detail.error === "upgrade_required"
  );
}

export function upgradeMessage(err) {
  return err?.response?.data?.detail?.message || "This is a paid feature. Upgrade to unlock it.";
}

export function extractPaywallInfo(err) {
  const d = err?.response?.data?.detail;
  if (!d || typeof d !== "object") return null;
  return {
    // Not "Daily limit reached." — this same payload carries monthly-allowance
    // and fair-use refusals, and naming the wrong period is a claim we can't
    // support. The server always sends `message`; this is only a last resort.
    message: d.message || "You're out of scans right now.",
    plan: d.plan || "free",
    quotaModel: d.quota_model || null,
    capReached: d.cap_reached || "account",
    accountUsed: d.account_used ?? 0,
    accountLimit: d.account_limit ?? 0,
    ipUsed: d.ip_used ?? 0,
    ipLimit: d.ip_limit ?? 0,
    nextReset: d.next_reset || null,
  };
}

/** Human-friendly hours-until countdown from ISO datetime. */
export function timeUntil(isoStr) {
  if (!isoStr) return "";
  try {
    const target = new Date(isoStr).getTime();
    const now = Date.now();
    const diff = Math.max(0, target - now);
    const h = Math.floor(diff / (1000 * 60 * 60));
    const m = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    if (h > 0) return `${h}h ${m}m`;
    return `${m}m`;
  } catch (_) {
    return "";
  }
}
